module.exports = __webpack_public_path__ + "img/heart-white-active.54291a72.svg";